import React from "react";
import { BusinessPayment } from "../../../service/model/business-payment.model";
import { Card, CardContent, Grid, styled, Typography } from "@mui/material";
import { CheckCircleOutlineIcon } from "../../../shared/icons";

const StyledCard = styled(Card)(({ theme }) => ({
    marginTop: "12px",
    '& .MuiCardContent-root': {
        paddingBottom: '12px !important',
    }
}));

interface PaymentHistoryProps {
    payments: BusinessPayment[];
}

const PaymentHistory: React.FC<PaymentHistoryProps> = ({ payments }) => {

    return (
        <div style={{ marginTop: '12px' }}>
            <Typography variant="h6">Payment History</Typography>
            {payments.map(payment => {
                return <StyledCard key={payment.id}>
                    <CardContent sx={{ paddingBottom: "12px" }}>
                        <Grid container direction="row" justifyContent="space-around">
                            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                                {payment.paymentDate}
                            </Typography><Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                                {`Rs. ${payment.amount}`}
                            </Typography>
                            <CheckCircleOutlineIcon color="success" />
                        </Grid>
                    </CardContent>
                </StyledCard>
            })

            }
        </div>
    );
}

export default PaymentHistory;